<template>


  <!--  </page-header-wrapper>-->
  <div class="big-screen" ref="bigScreen">
    <button
      @click="toggleFullScreen"
      style="position:absolute;top:20px;right:40px;z-index:10;padding:6px 16px;border-radius:6px;border:none;background:#1abc9c;color:#fff;cursor:pointer;font-size:16px;box-shadow:0 2px 8px rgba(0,0,0,0.08);">
      {{ isFullScreen ? '窗口化' : '全屏' }}
    </button>
    <div class="top-layer">Joeme数据大屏</div>
    <!-- 第一层：三个透明方框显示文字和数量统计数 -->
    <div class="first-layer">
      <div class="stat-box" v-for="(stat, index) in stats" :key="index">
        <p class="stat-label">{{ stat.label }}</p>
        <p class="stat-value">{{ stat.value }}</p>
      </div>
    </div>
    <!-- 第二层：两个饼图的引入的 echarts 的可滚动的图例 -->
    <div class="second-layer">
      <div id="pie-chart-1"></div>
      <div id="pie-chart-2"></div>
    </div>
    <!-- 第三层：左边是 echarts 的折柱混合的柱状图，右边是可滚动的表格 -->
    <div class="third-layer">
      <div id="bar-line-chart"></div>
      <div class="scrollable-table">
        <table>
          <thead>
          <tr>
            <th>姓名</th>
            <th>体重</th>
            <th>身高</th>
            <th>性别</th>
          </tr>
          </thead>
          <tbody>
          <tr
            v-for="(item, index) in tableData"
            :key="item.id"
          >
            <td>{{ item.nickname }}</td>
            <td>{{ item.weight }}</td>
            <td>{{ item.height }}</td>
            <td>{{ item.sex }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { timeFix } from '@/utils/util'
import { mapGetters } from 'vuex'
import { PageHeaderWrapper } from '@/components/ProLayout'
import ruoyiLogo from '@/assets/projects/ruoyi.png'
import antdvLogo from '@/assets/projects/antdv.png'
import { getUserProfile } from '@/api/system/user'
import axios from 'axios';
import * as echarts from 'echarts';
import {getLargeScreenUserNum,getOnlineUserCount,getThreeDayOnlineUser,getUserAgeData,getSleepUser,getErrorData,getNewUserList} from "@/api/joe/weight";


export default {
  name: 'Index',
  components: {
    PageHeaderWrapper
  },
  data () {
    return {

      largeScreenUserNum: 0,
      threeDayOnlineUser: 0,
      onlineUserCount: 0,
      // 贡献者
      contributors: [
        {
          name: 'wangze',
          avatar: 'https://portrait.gitee.com/uploads/avatars/user/1662/4988475_fuzui_1586973704.png!avatar60',
          email: '73400@163.com'
        }
      ],
      // 赞助
      sponsorList: [
        {
          key: 'RuoYi',
          tab: 'RuoYi'
        },
        {
          key: 'Antdv',
          tab: 'Antdv'
        }
      ],
      noTitleKey: 'RuoYi',
      timeFix: timeFix(),
      // 用户信息
      user: {
        dept: {
          deptName: ''
        }
      },
      roleGroup: {},
      postGroup: {},
      // 致谢项目
      projects: [
        {
          logo: ruoyiLogo,
          name: 'RuoYi-Vue',
          description: '基于SpringBoot，Spring Security，JWT，Vue & Element 的前后端分离权限Joeme管理系统。',
          website: 'http://ruoyi.vip',
          downloadUrl: 'https://gitee.com/y_project/RuoYi-Vue'
        },
        {
          logo: antdvLogo,
          name: 'Ant Design Vue',
          description: 'An enterprise-class UI components based on Ant Design and Vue. ',
          website: 'https://antdv.com',
          downloadUrl: 'https://github.com/vueComponent/ant-design-vue/'
        },
        {
          logo: antdvLogo,
          name: 'Antd Pro Vue',
          description: 'An out-of-box UI solution for enterprise applications as a Vue boilerplate. based on Ant Design of Vue.',
          website: 'https://pro.antdv.com',
          downloadUrl: 'https://github.com/vueComponent/ant-design-vue/'
        }
      ],

      stats: [],
      pieChart1Data: [],
      pieChart2Data: [],
      barLineChartData: {
        barData: [],
        lineData: [],
        xAxisData: []
      },
      tableData: [],
      highlightedIndex: -1,
      rowHeight: 0,
      scrollInterval: null,
      isFullScreen: false,
    }
  },
  computed: {
    ...mapGetters([
      'avatar',
      'nickname'
    ])
  },
  created () {

    // this.getUser()
    // this.fetchData();
    // this.initPieCharts();
    // this.initBarLineChart();
    // this.$nextTick(() => {
    //   this.setRowHeightAndStartScroll();
    // });
  },
  mounted() {
    this.getUser()
    this.fetchData();
    this.initPieCharts();
    this.initBarLineChart();
    this.getErrorData()
    this.$nextTick(() => {
      this.setRowHeightAndStartScroll();
    });
    // this.initPieCharts();
    this.getUserAgeData();
    this.getSleepUser();
    this.getLargeScreenUserNum()
    this.getOnlineUserCount()
    this.getThreeDayOnlineUser()
    this.getUserAgeData()
    this.getSleepUser()

    this.getNewUserList()

  },
  beforeDestroy() {
    this.clearScrollInterval();
  },
  watch: {
    tableData: {
      handler() {
        this.$nextTick(() => {
          this.setRowHeightAndStartScroll();
        });
      },
      deep: true
    }
  },
  methods: {
    // 获取用户信息
    getUser () {
      getUserProfile().then(response => {window.console.log('response 111',response)
        this.user = response.data
        this.roleGroup = response.roleGroup
        this.postGroup = response.postGroup
      })
    },
    onSponsorTabChange (key, type) {
      this[type] = key
    },
    getLargeScreenUserNum() {
      getLargeScreenUserNum().then(response => {
        this.largeScreenUserNum = response.data.value
        this.stats.push({ "label": "平台用户量", "value": this.largeScreenUserNum})
      })
    },


    getOnlineUserCount() {
      getOnlineUserCount().then(response => {
        this.onlineUserCount = response.data.value
        this.stats.push({ "label": "在线用户量", "value": this.onlineUserCount})
      })
    },

    getThreeDayOnlineUser() {
      getThreeDayOnlineUser().then(response => {
        this.threeDayOnlineUser = response.data.value
        this.stats.push({ "label": "三天内在线用户", "value": this.threeDayOnlineUser})
      })
    },


    getUserAgeData() {
      getUserAgeData().then(response => {
        this.pieChart1Data = response.data
        this.updatePieCharts();
      })
    },
    getSleepUser() {
      getSleepUser().then(response => {
        this.pieChart2Data = response.data
      })
    },

    getErrorData() {
      getErrorData().then(response => {
        this.barLineChartData = response.data
        this.updateBarLineChart();
      })
    },

    getNewUserList() {
      getNewUserList().then(response => {
        this.tableData = response.data
      })
    },

    async fetchData() {
      try {
        // 模拟从 API 获取统计数据

        console.log(1111111111111)
        // this.stats = [
        //   {
        //     "label": "平台用户量",
        //     "value": this.largeScreenUserNum
        //   },
        //   {
        //     "label": "在线用户量",
        //     "value": this.onlineUserCount
        //   },
        //   {
        //     "label": "三天内在线用户",
        //     "value": this.threeDayOnlineUser
        //   }
        // ];
        console.log(this.stats)






        this.updatePieCharts();
        this.updateBarLineChart();
      } catch (error) {
        console.error('数据获取失败:', error);
      }
    },
    initPieCharts() {
      this.pieChart1Instance = echarts.init(document.getElementById('pie-chart-1'));
      this.pieChart2Instance = echarts.init(document.getElementById('pie-chart-2'));
      window.addEventListener('resize', () => {
        this.pieChart1Instance.resize();
        this.pieChart2Instance.resize();
      });
    },
    updatePieCharts() {
      console.log(222222222222222)
      console.log(this.pieChart1Data)
      const pieOption = {
        title: {
          text: '用户年龄分布', // 主标题内容
          left: 'center',     // 标题居中
          top: 20,            // 距离顶部20px
          textStyle: {
            color: '#222',    // 标题颜色（根据你的背景色调整）
            fontSize: 18,
            fontWeight: 'bold'
          }
        },
        legend: {
          type: 'scroll',
          orient: 'vertical',
          right: 10,
          top: 'middle',
          data: this.pieChart1Data.map(item => item.name)
        },
        series: [
          {
            type: 'pie',
            radius: '50%',
            center: ['50%', '50%'],
            data: this.pieChart1Data
          }
        ]
      };
      this.pieChart1Instance.setOption(pieOption);

      const pieOption2 = {
        title: {
          text: '用户睡眠饼图', // 主标题内容
          left: 'center',     // 标题居中
          top: 20,            // 距离顶部20px
          textStyle: {
            color: '#222',    // 标题颜色（根据你的背景色调整）
            fontSize: 18,
            fontWeight: 'bold'
          }
        },
        legend: {
          type: 'scroll',
          orient: 'vertical',
          right: 10,
          top: 'middle',
          data: this.pieChart2Data.map(item => item.name)
        },
        series: [
          {
            type: 'pie',
            radius: '50%',
            center: ['50%', '50%'],
            data: this.pieChart2Data
          }
        ]
      };
      this.pieChart2Instance.setOption(pieOption2);
    },
    initBarLineChart() {
      this.barLineChartInstance = echarts.init(document.getElementById('bar-line-chart'));
      window.addEventListener('resize', () => {
        this.barLineChartInstance.resize();
      });
    },
    updateBarLineChart() {
      const barLineOption = {
        title: {
          text: '本周异常数据', // 主标题内容
          left: 'center',     // 标题居中
          top: 20,            // 距离顶部20px
          textStyle: {
            color: '#222',    // 标题颜色（根据你的背景色调整）
            fontSize: 18,
            fontWeight: 'bold'
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        legend: {
          data: ['柱状图']
        },
        xAxis: {
          type: 'category',
          data: this.barLineChartData.xAxisData
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '异常数量',
            type: 'bar',
            data: this.barLineChartData.barData
          },
          // {
          //   name: '折线图',
          //   type: 'line',
          //   data: this.barLineChartData.lineData
          // }
        ]
      };
      this.barLineChartInstance.setOption(barLineOption);
    },
    isRowHighlighted(index) {
      return index === this.highlightedIndex;
    },
    highlightRow(index) {
      this.highlightedIndex = index;
    },
    unhighlightRow(index) {
      this.highlightedIndex = -1;
    },
    setRowHeightAndStartScroll() {
      const row = this.$el.querySelector('.table-body tr');
      if (row) {
        this.rowHeight = row.offsetHeight;
        this.startScrolling();
      } else {
        console.warn('未能获取到表格行，无法设置行高和启动滚动');
      }
    },
    startScrolling() {
      this.clearScrollInterval(); // 清除可能存在的旧定时器
      if (this.tableData.length > 0) {
        this.scrollInterval = setInterval(() => {
          const tableBody = this.$el.querySelector('.table-body');
          if (tableBody) {
            const firstRow = tableBody.firstElementChild;
            if (firstRow) {
              tableBody.style.transform = `translateY(-${this.rowHeight}px)`;
              tableBody.style.transition = 'transform 0.5s ease-in-out';
              setTimeout(() => {
                tableBody.removeChild(firstRow);
                tableBody.appendChild(firstRow);
                tableBody.style.transform = 'translateY(0)';
                tableBody.style.transition = 'none';
              }, 500);
            }
          }
        }, 1000);
      }
    },
    clearScrollInterval() {
      if (this.scrollInterval) {
        clearInterval(this.scrollInterval);
        this.scrollInterval = null;
      }
    },
    toggleFullScreen() {
      const el = this.$refs.bigScreen;
      if (!this.isFullScreen) {
        if (el.requestFullscreen) {
          el.requestFullscreen();
        } else if (el.mozRequestFullScreen) {
          el.mozRequestFullScreen();
        } else if (el.webkitRequestFullscreen) {
          el.webkitRequestFullscreen();
        } else if (el.msRequestFullscreen) {
          el.msRequestFullscreen();
        }
        this.isFullScreen = true;
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
        this.isFullScreen = false;
      }
    },
  }
}
</script>

<style lang="less" scoped>
@import "./index.less";
blockquote {
  padding: 0 1em;
  color: #6a737d;
  border-left: 0.25em solid #dfe2e5;
}
.project-list {

  .card-title {
    font-size: 0;

    a {
      color: rgba(0, 0, 0, 0.85);
      margin-left: 12px;
      line-height: 24px;
      height: 24px;
      display: inline-block;
      vertical-align: top;
      font-size: 14px;

      &:hover {
        color: #1890ff;
      }
    }
  }

  .card-description {
    color: rgba(0, 0, 0, 0.45);
    height: 66px;
    line-height: 22px;
    overflow: hidden;
  }

  .project-item {
    display: flex;
    margin-top: 8px;
    overflow: hidden;
    font-size: 12px;
    height: 20px;
    line-height: 20px;

    a {
      color: rgba(0, 0, 0, 0.45);
      display: inline-block;
      flex: 1 1 0;

      &:hover {
        color: #1890ff;
      }
    }

    .download {
      color: rgba(0, 0, 0, 0.25);
      flex: 0 0 auto;
      float: right;
    }
  }

  .ant-card-meta-description {
    color: rgba(0, 0, 0, 0.45);
    height: 44px;
    line-height: 22px;
    overflow: hidden;
  }
}

.item-group {
  padding: 20px 0 8px 24px;
  font-size: 0;

  a {
    color: rgba(0, 0, 0, 0.65);
    display: inline-block;
    font-size: 14px;
    margin-bottom: 13px;
    width: 25%;
  }
}

.mobile {

  .project-list {

    .project-card-grid {
      width: 100%;
    }
  }

  .more-info {
    border: 0;
    padding-top: 16px;
    margin: 16px 0 16px;
  }

  .headerContent .title .welcome-text {
    display: none;
  }
}

.big-screen {
  /* 好看的渐变色，兼容图表和文字可读性 */
  background: linear-gradient(135deg, #f8fffe 0%, #1abc9c 60%, #43e97b 100%);
  color: #222; /* 建议主文字用深色，图表内文字可单独设置为白色 */
  display: flex;
  flex-direction: column;
  height: 100vh;
  padding: 20px;
  gap: 20px;
}

.top-layer {
  text-align: center;
  font-size: 24px;
}

.first-layer {
  display: flex;
  justify-content: space-around;
  flex: 1;
  gap: 20px;
}

.stat-box {
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  padding: 20px;
  text-align: center;
  width: 30%;
  /* 添加阴影效果 */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  transition: transform 0.3s ease;
}

.stat-box:hover {
  transform: scale(1.05);
}

.stat-label {
  font-size: 18px;
  margin-bottom: 10px;
}

.stat-value {
  font-size: 24px;
  font-weight: bold;
}

.second-layer {
  display: flex;
  flex: 2;
  gap: 20px;
}

#pie-chart-1 {
  width: 50%;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}
#pie-chart-2 {
  width: 50%;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.third-layer {
  display: flex;
  flex: 3;
  gap: 20px;
}

#bar-line-chart {
  width: 60%;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.scrollable-table {
  width: 40%;
  overflow: hidden;
  border: 1px solid #333;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

table {
  border-collapse: collapse;
  width: 100%;
}

th,
td {
  border: 1px solid #333;
  padding: 8px;
  text-align: left;
}

.highlight {
  background-color: #336699;
}

.table-body {
  will-change: transform;
}
</style>
